//Выбранные достижения
import {create} from "zustand";

export interface IStep {
    currentStep: number,
    completedSteps: number[],
    skippedSteps: number[],
    nextStep: boolean,
    backStep: number,
    forwardStep: number
}

export interface ISteps {
    stepsData: IStep
    setStepsData: (newData: IStep) => void
}

export const stepsStore = create<ISteps>()((set) => ({
    stepsData: {
        currentStep: 0,
        completedSteps: [],
        skippedSteps: [],
        nextStep: false,
        backStep: 0,
        forwardStep: 0
    },
    setStepsData: (newData: IStep) => set((state) => ({stepsData: newData})),
}))

export const defaultFilter =
    {
        basistraining: null,
        kindsLevelFormation: null,
        name: null,
        kindsTraining: null,
        competition: null
    }

export interface IFilter {
    basistraining: string | null,
    kindsLevelFormation: string | null,
    name: string | null,
    kindsTraining: string | null,
    competition: string | null
}

export interface IFilterState {
    filter: IFilter,
    setFilter: (newData: IFilter) => void
}

export const filterStore = create<IFilterState>()((set) => ({
    filter: defaultFilter,
    setFilter: (newData: IFilter) => set((state) => ({filter: newData})),
}))